export default [
  {
    path: 'lessons',
    component: () => import('../views/Lessons'),
    children: [
      {
        path: '/',
        name: 'lessons-index',
        component: () => import('../views/Index')
      },
      {
        path: 'modules/:moduleid/create',
        name: 'lessons-create',
        component: () => import('../views/Create')
      },
      {
        path: ':id/edit',
        name: 'lessons-edit',
        component: () => import('../views/Edit')
      }
    ]
  }
];
